// import {  ref } from 'vue'
// import { get } from '../../../utils/index'

/**
 * 药械闪加公共函数处理
 */
export function useFlashAddMedical(emit) {
  // 将选中数据，input出去
  const emitData = (data) => {
    emit('input', data)
  }

  const emitComponentData = (data) => {
    emit('getMedicalData', data)
  }
  return {
    emitData,
    emitComponentData,
  }
}
